import { render, staticRenderFns } from "./OpenAccountProcess.vue?vue&type=template&id=7f8b4b30&scoped=true&"
import script from "./OpenAccountProcess.vue?vue&type=script&lang=js&"
export * from "./OpenAccountProcess.vue?vue&type=script&lang=js&"
import style0 from "./OpenAccountProcess.vue?vue&type=style&index=0&id=7f8b4b30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b4b30",
  null
  
)

export default component.exports